import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { OverlayRef } from '@angular/cdk/overlay';
import { MatLegacyAutocomplete as MatAutocomplete } from '@angular/material/legacy-autocomplete';
import { Subject } from 'rxjs';
import { COMMA, ENTER } from '@angular/cdk/keycodes';

import { Property } from 'app/modules/projects/projects.types';
import { Project } from 'app/modules/projects/projects.types';
import { Account, Activity } from 'app/core/models/account.types';
import { User } from 'app/core/models/user.types';
import { Note } from '../../../shared/modules/notes/notes.types';
import { AccountService } from 'app/core';
import { MatDrawer } from '@angular/material/sidenav';
import { AggregatedTasksService } from 'app/modules/aggregated-tasks/aggregated-tasks.service';

@Component({
  selector: 'properties-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertiesDetailsComponent implements OnInit, OnDestroy {
  editMode: boolean;
  foundTags: string[];
  property: Property;
  contactForm: UntypedFormGroup;
  properties: Property[];
  projects: Project[];
  notes: Note[];
  tasks: any[];
  account: Account;
  activities: Activity[];
  workflowStates: any[];

  tagCtrl: UntypedFormControl;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  visible = true;
  selectable = true;
  removable = true;

  // Private
  private _tagsPanelOverlayRef: OverlayRef;
  private _unsubscribeAll: Subject<void>;
  public drawerMode: 'over' | 'side';
  public drawerOpened: boolean;
  public showTask = false;

  @ViewChild('matDrawer', { static: true })
  matDrawer: MatDrawer;

  @ViewChild('avatar')
  private _avatar: ElementRef;

  @ViewChild('avatarFileInput')
  private _avatarFileInput: ElementRef;

  @ViewChild('tagsPanel')
  private _tagsPanel: TemplateRef<any>;

  @ViewChild('tagsPanelOrigin')
  private _tagsPanelOrigin: ElementRef;

  @ViewChild('tagInput')
  tagInput: ElementRef<HTMLInputElement>;

  @ViewChild('auto')
  matAutocomplete: MatAutocomplete;

  users: User[];

  /**
   * Constructor
   *
   * @param {ActivatedRoute} _activatedRoute
   * @param {ChangeDetectorRef} _changeDetectorRef
   * @param {ContactsListComponent} _contactsListComponent
   * @param {ContactsService} _contactsService
   * @param {FormBuilder} _formBuilder
   * @param {Renderer} _renderer2
   * @param {Router} _router
   * @param {Overlay} _overlay
   * @param {ViewContainerRef} _viewContainerRef
   */
  constructor(
    private _router: Router,
    private _accountService: AccountService,
    private _aggregatedTasksService: AggregatedTasksService,
  ) {
    // Set the private defaults
    this._unsubscribeAll = new Subject();

    // Set the defaults
    this.editMode = false;

    this.tagCtrl = new UntypedFormControl();

    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
      this._aggregatedTasksService.accountId = this.account.id;
    });

    this.drawerMode = 'side';
    this.drawerOpened = false;
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {}

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions

    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  /**
   * Track by function for ngFor loops
   *
   * @param index
   * @param item
   */
  trackByFn(index: number, item: any): any {
    return item.id || index;
  }
}
